import {
  SIZE_RANK,
  getCreatureSizeRank,
  getLegalPushDestinations,
  normalizeCreatureSize,
} from './pushGeometry';

export const PUSH_DEFINITION_ID = 'weapon-mastery:push';

const masteryKey = (attack) => String(
  attack?.mastery?.key || attack?.mastery?.id || attack?.mastery?.label || ''
).trim().toLowerCase();

const combatantId = (participant) => String(
  participant?.characterId || participant?.enemyId || participant?.combatantId || participant?.id || ''
);

export const isPushMasteryAttack = (attack) => Boolean(
  attack?.kind === 'weapon' && attack?.hasWeaponMastery && masteryKey(attack) === 'push'
);

export const getPushSpatialContext = ({ attackerId, targetId, attacker, target, combatState, spatialContext }) => {
  const participants = Array.isArray(combatState?.participants) ? combatState.participants : [];
  const ids = new Set(participants.map(combatantId));
  const map = spatialContext?.map;
  const tokens = spatialContext?.tokens || map?.tokens || {};
  const sourceToken = tokens?.[attackerId];
  const targetToken = tokens?.[targetId];
  const sourceSize = normalizeCreatureSize(attacker?.size || sourceToken?.size || 'medium');
  const targetSize = normalizeCreatureSize(target?.size || target?.creatureSize || targetToken?.size);
  if (!map || !ids.has(String(attackerId)) || !ids.has(String(targetId)) || !sourceToken || !targetToken || !targetSize) return null;
  return { map, sourceToken, targetToken, sourceSize, targetSize };
};

export const qualifiesForPush = ({ attack, outcome, attackerId, targetId, attacker, target, combatState, spatialContext }) => {
  if (!isPushMasteryAttack(attack) || !['hit', 'critical-hit'].includes(outcome) ||
      !attackerId || !targetId || !Number.isInteger(combatState?.turnSequence) || combatState?.activeTurn == null) return false;
  const context = getPushSpatialContext({ attackerId, targetId, attacker, target, combatState, spatialContext });
  const rank = getCreatureSizeRank(context?.targetSize);
  return context != null && rank != null && rank <= SIZE_RANK.large &&
    getLegalPushDestinations({
      sourceToken: context.sourceToken, sourceSize: context.sourceSize,
      targetToken: context.targetToken, targetSize: context.targetSize, map: context.map,
    }).length > 0;
};

export const createPushDecision = (resolutionId, destinations) => ({
  id: `${resolutionId}:${PUSH_DEFINITION_ID}`,
  featureId: PUSH_DEFINITION_ID,
  resolutionId,
  title: 'Weapon Mastery: Push',
  label: 'Weapon Mastery: Push',
  prompt: 'Push this creature up to 10 feet straight away?',
  choices: [
    ...destinations.map(({ distanceFeet }) => ({ id: `push-${distanceFeet}`, label: `Push ${distanceFeet} ft`, variant: 'primary' })),
    { id: 'skip', label: 'Skip' },
  ],
});

export const getPushOptions = (input) => {
  const context = getPushSpatialContext(input);
  if (!context) return [];
  return getLegalPushDestinations({
    sourceToken: context.sourceToken, sourceSize: context.sourceSize,
    targetToken: context.targetToken, targetSize: context.targetSize, map: context.map,
  });
};
